import {Component, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {Report} from '../../../../models/measure/report';
import {CommonConstant, longLetters, shortLetters} from '../../../app.constants';
import {TranslateService} from '@ngx-translate/core';
import {AchooTextFieldComponent} from '../../../core/achoo-text-field/achoo-text-field.component';
import {AchooFilterBoxComponent} from '../../../core/achoo-filter-box/achoo-filter-box.component';
import {UserService} from '../../../services/user.service';
import {EventTrackerService, Page, UserActionType} from '../../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'measure-breadcumb',
  templateUrl: './measure-breadcumb.component.html',
  styleUrls: ['./measure-breadcumb.component.scss']
})
export class MeasureBreadcumbComponent implements OnChanges {

  @ViewChild('reportNameInputField')
  public reportNameInputField: AchooTextFieldComponent;
  @ViewChild('ReportSelection')
  public reportSelection: AchooFilterBoxComponent;

  @Input()
  reportList: Report[] = [];
  @Input()
  public selectReport: Report = new Report();
  @Input()
  canEditReport: false;
  @Output()
  selectReportEvent: EventEmitter<Report> = new EventEmitter<Report>();

  selectedReportId: number;

   public showReportList = false;

  ngOnChanges(changes) {
    if (changes.reportList && changes.reportList.currentValue.length > 0) {
       this.showReportList = true;
       // deplay to update arrow position
       setTimeout(() => this.updateArrowPosition(this.selectReport.name));
    }

    if (changes.selectReport) {
      this.selectedReportId = changes.selectReport.currentValue.id;
    }
  }

  constructor(private translate: TranslateService,
              public userService: UserService,
              public eventTracker: EventTrackerService) {
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  public onSelectReport(e) {
    if (e) {
      const newSelectedReport = this.reportList.find(report => report.id === this.selectedReportId);
      if (newSelectedReport) {
        this.selectReport  = newSelectedReport;
        this.selectReportEvent.emit(newSelectedReport);
      }
    }
  }

  public updateArrowPosition(reportName, arrowOffsetLeft?: number) {
    if (!this.selectReport || !this.reportSelection) {
      return ;
    }
    let reportFieldWidth;
    // use for fixed position
    if (arrowOffsetLeft) {
      reportFieldWidth = arrowOffsetLeft;
    } else if (!reportName || reportName.length === 0) {
      reportFieldWidth = CommonConstant.MAX_LENGTH_REPORT_NAME_FIELD;
    } else if (reportName.length > 0) {
      // dynamaic position
      let lengthOfUppercaseLetters = 0;
      let lengthOfLowercaseLetters = 0;
      for (let i = 0; i < reportName.length; i++) {
        if (this.isUpppercaseCharacter(reportName.charAt(i))) {
          lengthOfUppercaseLetters += this.calculateUppercaseLetterLength(reportName.charAt(i));
        } else {
          lengthOfLowercaseLetters += this.calculateLowercaseLetterLength(reportName.charAt(i));
        }
      }
      reportFieldWidth = lengthOfUppercaseLetters + lengthOfLowercaseLetters;
    }

    // update arrow position base on width of report name
    if (this.reportNameInputField && reportFieldWidth) {
      this.reportNameInputField._entryElement.nativeElement.style.width = reportFieldWidth + 'px';
      this.reportSelection.ngSelect.elementRef.nativeElement.style.backgroundPositionX = reportFieldWidth + 'px';
    }
  }

  private isUpppercaseCharacter(chr) {
    return chr !== ' ' && chr === chr.toUpperCase();
  }

  /**
   * this method is used to calculate the length of uppercase character
   * @param letter
   * @returns {number}
   */
  private calculateUppercaseLetterLength(letter) {
    // need 32px for long upper-case letter
    if (longLetters.indexOf(letter.toLowerCase()) >= 0) {
      return CommonConstant.UPPER_CASE_LONG_LETTER_LENGTH;
    } else if (shortLetters.indexOf(letter.toLowerCase()) >= 0) {
      // need 25px for normal upper-case letter
      return CommonConstant.UPPER_CASE_SHORT_LETTER_LENGTH;
    } else {
      // need 30px for normal upper-case letter
      return CommonConstant.UPPER_CASE_NORMAL_LETTER_LENGTH;
    }
  }

  /**
   * this method is used to calculate the length of lowercase character
   * @param letter
   * @returns {number}
   */
  private calculateLowercaseLetterLength(letter) {
    // need 32px for long upper-case letter
    if (longLetters.indexOf(letter) >= 0) {
      return CommonConstant.LOWER_CASE_LONG_LETTER_LENGTH;
    } else if (shortLetters.indexOf(letter) >= 0 ) {
      // need 15px for normal upper-case letter
      return CommonConstant.LOWER_CASE_SHORT_LETTER_LENGTH;
    }  else {
      // need 30px for normal upper-case letter
      return CommonConstant.LOWER_CASE_NORMAL_LETTER_LENGTH;
    }
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-breadcumb/measure-breadcumb.component.ts